import { useEffect, useState } from 'react'

const useIsRTL = (instanceId?: string): boolean => {
  const [current, setCurrent] = useState<boolean>(false)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_isRTL', ((e: CustomEvent) => handleChange(e)) as EventListener)
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_isRTL'))

    return () => {
      document.removeEventListener('retorik_isRTL', ((e: CustomEvent) => handleChange(e)) as EventListener)
    }
  }, [])

  return current
}

export default useIsRTL
